/**
 * src/pages/NotFoundPage.tsx
 * =============================================================================
 * Página 404.
 * Minimal por ahora — se pulirá cuando haya identidad visual definida.
 * Textos vía i18n (claves `noEncontrada.*`).
 * =============================================================================
 */

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <main className="min-h-dvh flex items-center justify-center px-6">
      <div className="text-center space-y-4">
        <p className="text-sm text-muted-foreground">404</p>
        <h1 className="text-xl font-semibold">{t('noEncontrada.titulo')}</h1>
        <Link
          to="/"
          className="inline-block text-sm underline underline-offset-4 text-muted-foreground hover:text-foreground"
        >
          {t('noEncontrada.volver')}
        </Link>
      </div>
    </main>
  )
}
